export default __webpack_public_path__ + "static/media/guarant.032387f0.svg";